// extracted by mini-css-extract-plugin
export var section = "slider-module--section--f3iJ0";
export var sliderSection = "slider-module--sliderSection--amooL";